module.exports = __webpack_public_path__ + "942a973280f23fc97d26a3bbc3fd4a8b.jpg";